export default __webpack_public_path__ + "static/media/colonial-calculator4.54afa222.jpg";